import { render, staticRenderFns } from "./experienceClassRoom.vue?vue&type=template&id=74bae08f&scoped=true"
import script from "./experienceClassRoom.vue?vue&type=script&lang=js"
export * from "./experienceClassRoom.vue?vue&type=script&lang=js"
import style0 from "./experienceClassRoom.vue?vue&type=style&index=0&id=74bae08f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bae08f",
  null
  
)

export default component.exports